'use client'

// src/api/queries/theme.ts
var THEME_QUERY = `
primary
secondary
tertiary
action
textPrimary
primaryContrast
body
font {
    url
    contentType
}
bodyFont {
    url
    contentType
}
`;

export {
  THEME_QUERY
};
//# sourceMappingURL=chunk-X74FHHFA.mjs.map